// TERMINAL — dark mono console. Fixed-dark template (darkDefault: true):
// paints its own literal console palette regardless of theme tokens, with
// the brand accent used for the prompt "$" glyphs and the "# title" line.
// Every question reads as a prompt line with a [nn] index; answers print
// below in the muted console color.
const TERM_BG = '#0b1220';
const TERM_INK = '#e6f0ff';
const TERM_SUB = '#9fb3cc';
const TERM_BORDER = 'rgba(255, 255, 255, 0.1)';
function itemHtml(ctx, it) {
    return `<div class="fq-acc">
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="term-p-${it.idx}">
    <span class="fq-ps">$</span>
    <span class="fq-q">${it.q}</span>
    <span class="fq-num">[${it.num}]</span>
  </button>
  <div class="fq-panel" id="term-p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const terminal = {
    id: 'terminal',
    name: 'Terminal',
    tag: 'Console list',
    styleTag: 'Dark mono',
    description: 'A monospace console: every question is a prompt line, every answer prints below it. Made for dev tools, APIs, and anyone whose audience lives in a terminal.',
    layout: 'accordion',
    defaultAccent: '#0e8f7e',
    darkDefault: true,
    catSupport: 'none',
    features: ['accordion'],
    render(ctx) {
        const html = `<div class="fq-con">
  <p class="fq-prompt" aria-hidden="true">visitor@${ctx.hostLabel}:~$ faq --list</p>
  <h2 class="fq-title"># ${ctx.title}</h2>
  <div class="fq-list">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-con{max-width:720px;margin:0 auto;padding:28px 30px 32px;border-radius:${ctx.v.radiusCard};background:${TERM_BG};font-family:${ctx.v.mono}}
.FQM .fq-prompt{margin:0 0 4px;font-size:12.5px;color:${TERM_SUB}}
.FQM .fq-title{margin:0 0 22px;font-size:24px;font-weight:700;letter-spacing:-0.01em;color:${ctx.v.accent}}
.FQM .fq-list{display:flex;flex-direction:column}
.FQM .fq-acc{border-top:1px solid ${TERM_BORDER}}
.FQM .fq-qbtn{display:flex;width:100%;align-items:baseline;gap:12px;padding:15px 2px}
.FQM .fq-ps{flex:0 0 auto;font-size:14px;color:${ctx.v.accent}}
.FQM .fq-q{flex:1;font-size:14.5px;line-height:1.5;color:${TERM_INK}}
.FQM .fq-num{flex:0 0 auto;font-size:11px;color:${TERM_SUB}}
.FQM .fq-a{padding:0 30px 18px 26px;font-size:13.5px;line-height:1.75;color:${TERM_SUB}}
`;
        return { html, css };
    },
};
export default terminal;
